import { Stack, Typography } from '@mui/material';
import { useSession } from '@side/next-auth/react';
import { formatDate } from '@side/pantry';
import { useUserInformation } from '@/common/hooks/useUserInformation/useUserInformation';
import { SectionContainer } from '@/views/Home/components/SectionContainer';
import { CustomizeButton } from './components/CustomizeButton';
import { getGreeting } from './helper';

export function WelcomeContainer() {
  const sessionUserId = useSession()?.data?.user?.id;
  const userInfo = useUserInformation(sessionUserId);

  const date = formatDate(new Date(), 'friendlyDate');
  const welcomeText = getGreeting(userInfo);

  return (
    <SectionContainer
      sx={{
        mt: { xs: 2, md: 3 },
        pb: { xs: 3, md: 2 },
      }}
    >
      <Stack
        id="pendo-home-welcome-banner"
        direction={{ xs: 'column', sm: 'row' }}
        sx={{
          justifyContent: { xs: 'space-between' },
          alignItems: 'flex-start',
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            width: { xs: '100%', sm: 'unset' },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: 'other.spaceCadet',
            }}
          >
            {welcomeText}
          </Typography>
        </Stack>
        <Stack sx={{ alignItems: { xs: 'flex-start', sm: 'flex-end' } }}>
          <Typography
            variant="body1"
            sx={{
              color: 'other.spaceCadet',
            }}
          >
            Today is {date}
          </Typography>
          <CustomizeButton />
        </Stack>
      </Stack>
    </SectionContainer>
  );
}
